import React from "react";
import DividoSignup from "./assets/images/divido-signup-page.webp";
import DividoDashboard from "./assets/images/divido-dashboard.webp";
import DiviDoAccount from "./assets/images/divido-account.webp";
import Nicholas from "./assets/images/divido-persona-jack.webp";
import Reena from "./assets/images/divido-persona-reena.webp";
import DividoSolutionSvg from "./assets/images/divido-solution.svg";
import DividoHomeWireframe from "./assets/images/divido-homepage-wireframe.webp";
import DividoSpentWireframe from "./assets/images/divido-spent-screen-wireframe.webp";
import DividoTransWireframe from "./assets/images/divido-transaction-wireframe.webp";
import DividoPaymentWireframe from "./assets/images/divido-payment-wireframe.webp";
import DividoSpent from "./assets/images/divido-spent.webp";
import DividoPayment from "./assets/images/divido-payment-hifi.webp";
import DividoTrans from "./assets/images/divido-transaction-hifi.webp";
import DividoFastag from "./assets/images/divido-billbox-hifi.webp";
import DividoSplit from "./assets/images/divido-split-screen-hifi.webp";
import Learnings from "./Learnings";
const DividoBody = () => {
  return (
    <>
      <section className="wrapper productpagebody divido-body">
        <section className="ecom-body">
          <div className="container">
            <h2 className="text-center fw-medium margin-set fs-56px mb-4">
              Manage Money, Master Life
            </h2>
            <div className="row justify-content-center">
              <div className="col-md-8 my-2">
                <div className="d-flex gap-3 flex-wrap justify-content-center justify-content-md-between">
                  <div className="divido-mob-img d-none d-md-block">
                    <img src={DividoSignup} alt="DiviDo" />
                  </div>
                  <div className="divido-mob-img">
                    <img src={DividoDashboard} alt="DiviDo" />
                  </div>
                  <div className="divido-mob-img d-none d-md-block">
                    <img src={DiviDoAccount} alt="DiviDo" />

                    
                  </div>
                </div>
                <p className="text-center text-md-end mt-16x">
                        <a href="https://www.figma.com/proto/5FjsG8S34o9WH8CLpHq8gx/Divido?page-id=5%3A2&node-id=126-42&p=f&viewport=687%2C253%2C0.21&t=jxJYHN6btG8JUXen-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=126%3A42" target="_blank" className="proto-link">View Prototype</a>
                    </p>
              </div>
            </div>
          </div>
        </section>
        <section className="short-description mb-5">
          <div className="container">
            <div className="row justify-content-between align-items-center">
              <div className="col-md-6 my-2">
                <h2 className="fs-36px">Product Overview</h2>
              </div>
              <div className="col-md-6 my-2">
                <p className="fs-24 lh-custom">
                  Designed a user-friendly BNPL finance app to help users manage
                  their finances effortlessly. The app provides clear
                  transaction insights, monthly spending summaries, and
                  budget-setting features while ensuring easy navigation and
                  timely due-date reminders.
                </p>
              </div>
            </div>
            <div className="row mt-3 justify-content-center align-items-center">
              <div className="col-md-4 my-2">
                <div className="card card-bg-secondary divido-bg h-100 pad-30x align-items-center justify-content-center w-305x ms-auto">
                  <h2 className="fs-24 mb-2 fw-normal mb-0">Timeline</h2>
                  <p className="fs-20 fw-normal mb-0">Dec 15 - Dec 30, 2025</p>
                </div>
              </div>
              <div className="col-md-4 my-2">
                <div className="card card-bg-secondary divido-bg h-100 pad-30x rounded-10x align-items-center justify-content-center w-338x me-auto">
                  <h2 className="fs-24 mb-2 fw-normal mb-0">Role</h2>
                  <p className="fs-20 fw-normal mb-0">
                    UX Researcher, UX Designer
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="brief-description my-5">
          <div className="container">
            <h2 className="fs-36px">Pain points</h2>
            <div className="row justify-content-between">
              <div className="col-md-5 mb-2">
                <div className="mini-title my-4">
                  <h2 className="fs-28x fm-soli text-center">User Insight</h2>
                </div>
                <div className="d-flex align-items-center gap-3 flex-wrap">
                  <div className="boxes">
                    <div className="card card-bg-secondary divido-bg h-100 justify-content-center rounded-10x align-items-center  px-3">
                      <p className="fs-20 fw-normal mb-0 lh-24px">
                        Budget tracking is unclear.
                      </p>
                    </div>
                  </div>
                  <div className="boxes">
                    <div className="card card-bg-secondary divido-bg h-100 justify-content-center rounded-10x align-items-center  px-3">
                      <p className="fs-20 fw-normal mb-0 lh-24px">
                        Users forget due dates.
                      </p>
                    </div>
                  </div>
                  <div className="boxes">
                    <div className="card card-bg-secondary divido-bg h-100 justify-content-center rounded-10x align-items-center  px-3">
                      <p className="fs-20 fw-normal mb-0 lh-24px">
                        Navigation feels complicated.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-5 mb-2">
                <div className="mini-title my-4">
                  <h2 className="fs-28x fm-soli text-center">
                    Pain point Analysis
                  </h2>
                </div>
                <div className="d-flex align-items-center gap-3 justify-content-end flex-wrap">
                  <div className="boxes">
                    <div className="card card-bg-secondary divido-bg h-100 justify-content-center rounded-10x align-items-center  px-3">
                      <p className="fs-20 fw-normal mb-0 lh-24px">
                        Lack of clear spending summary makes it difficult to
                        track monthly expenses.
                      </p>
                    </div>
                  </div>
                  <div className="boxes">
                    <div className="card card-bg-secondary divido-bg h-100 justify-content-center rounded-10x align-items-center  px-3">
                      <p className="fs-20 fw-normal mb-0 lh-24px">
                        No automated reminders lead to missed payments and late
                        fees.
                      </p>
                    </div>
                  </div>
                  <div className="boxes">
                    <div className="card card-bg-secondary divido-bg h-100 justify-content-center rounded-10x align-items-center  px-3">
                      <p className="fs-20 fw-normal mb-0 lh-24px">
                        Complex navigation hinders accessibility, making it hard
                        to manage finances efficiently.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="persona my-5">
          <div className="container">
            <h1 className="fs-36px mb-4">Persona</h1>
            <div className="row mb-2">
              <div className="col-md-8 my-2">
                <div className="card persona-card p-3 h-100">
                  <h4 className="fs-24 fw-medium">Goals</h4>
                  <ul className="persona-list">
                    <li>
                      Track monthly expenses effortlessly to stay within budget.
                    </li>
                    <li>
                      Set and adjust spending limits to avoid overspending.
                    </li>
                    <li>Receive timely bill reminders to avoid late fees.</li>
                  </ul>
                  <h4 className="fs-24 fw-medium">Challenges</h4>
                  <ul className="persona-list">
                    <li>
                      Struggles to keep track of multiple payments and
                      subscriptions.
                    </li>
                    <li>Finds it difficult to analyze spending patterns.</li>
                    <li>
                      Lacks financial awareness and often overspends without
                      realizing.
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-md-4 my-2">
                <div className="card persona-card p-3 h-100 justify-content-center align-items-center">
                  <div className="emily-img mb-4">
                    <img src={Nicholas} alt="Nicholas" class="img-cover" />
                  </div>
                  <h4 className="fs-24">Jack Nicholas</h4>
                  <p className="fs-24 role">College Student</p>
                </div>
              </div>
            </div>
            <div className="row mb-2 flex-row-reverse">
              <div className="col-md-8 my-2">
                <div className="card persona-card p-3 h-100">
                  <h4 className="fs-24 fw-medium">Goals</h4>
                  <ul className="persona-list">
                    <li>
                      Manage irregular income and plan for upcoming expenses.
                    </li>
                    <li>
                      Get insights into cash flow to balance savings and
                      spending.
                    </li>
                    <li>
                      Set up automatic reminders for upcoming bills and
                      invoices.
                    </li>
                  </ul>
                  <h4 className="fs-24 fw-medium">Challenges</h4>
                  <ul className="persona-list">
                    <li>Income fluctuates, making budgeting unpredictable.</li>
                    <li>
                      Finds it hard to separate personal and business expenses.
                    </li>
                    <li>
                      Needs an easy-to-use app with clear financial breakdowns.
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-md-4 my-2">
                <div className="card persona-card p-3 h-100 justify-content-center align-items-center">
                  <div className="emily-img mb-4">
                    <img src={Reena} alt="Reena" class="img-cover" />
                  </div>
                  <h4 className="fs-24">Reena John</h4>
                  <p className="fs-24 role">Freelancer</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="solution my-5">
          <div className="container">
            <div className="row">
              <h2 className="fs-36px mb-4">The Solution we came up with</h2>
              <div className="col-12">
                <div className="solution-svg img-contain mb-3">
                  <img src={DividoSolutionSvg} alt="Solutions" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="my-5">
          <div className="container">
            <h2 className="fs-36px mb-4 my-5">Ideation</h2>
            <div className="row justify-content-center">
              <div className="col-md-4 my-2 mb-4">
                <h2 className="text-center my-4 fs-28 fm-soli">Home</h2>
                <div className="wireframe-img divido-wf">
                  <img src={DividoHomeWireframe} alt="Wire frame" />
                </div>
              </div>
              <div className="col-md-4 my-2 mb-4">
                <h2 className="text-center my-4 fs-28 fm-soli">Spent</h2>
                <div className="wireframe-img divido-wf">
                  <img src={DividoSpentWireframe} alt="Wire frame" />
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-4 my-2 mb-4">
                <h2 className="text-center my-4 fs-28 fm-soli">Transaction</h2>
                <div className="wireframe-img divido-wf">
                  <img src={DividoTransWireframe} alt="Wire frame" />
                </div>
              </div>
              <div className="col-md-4 my-2 mb-4">
                <h2 className="text-center my-4 fs-28 fm-soli">Payment</h2>
                <div className="wireframe-img divido-wf">
                  <img src={DividoPaymentWireframe} alt="Wire frame" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="my-5">
          <div className="container">
            <h2 className="fs-36px mb-4 my-5">Prototype</h2>
            <div className="row mb-4 justify-content-between">
              <div className="col-md-5 my-3">
                <div className="d-flex align-items-center gap-3">
                  <div>
                    <h2 className="text-center my-4 fs-28 fm-soli">Home</h2>
                    <div className="prototype-img divido-proto mb-3 flex-shrink-0">
                      <img src={DividoDashboard} alt="Wire frame" />
                    </div>
                  </div>

                  <p className="fs-18 mt-2 lh-24px">
                    Provides an overview of all essential details, ensuring
                    nothing is missed, including key reminders. It also displays
                    monthly expenses, helping users stay mindful of their
                    finances.
                  </p>
                </div>
              </div>
              <div className="col-md-5 my-3">
                <div className="d-flex align-items-center gap-3">
                  <div>
                    <h2 className="text-center my-4 fs-28 fm-soli">Spent</h2>
                    <div className="prototype-img divido-proto mb-3 flex-shrink-0">
                      <img src={DividoSpent} alt="Wire frame" />
                    </div>
                  </div>

                  <p className="fs-18 mt-2 lh-24px">
                    Provides an overview of all essential details, ensuring
                    nothing is missed, including key reminders. It also displays
                    monthly expenses, helping users stay mindful of their
                    finances.
                  </p>
                </div>
              </div>
            </div>
            <div className="row mb-4 justify-content-between">
              <div className="col-md-5 my-3">
                <div className="d-flex align-items-center gap-3">
                  <div>
                    <h2 className="text-center my-4 fs-28 fm-soli">Payment</h2>
                    <div className="prototype-img divido-proto mb-3 flex-shrink-0">
                      <img src={DividoPayment} alt="Wire frame" />
                    </div>
                  </div>

                  <p className="fs-18 mt-2 lh-24px">
                    Shows all completed and ongoing transactions with clear
                    details. A globe icon visually represents loan progress and
                    related financial activities.
                  </p>
                </div>
              </div>
              <div className="col-md-5 my-3">
                <div className="d-flex align-items-center gap-3">
                  <div>
                    <h2 className="text-center my-4 fs-28 fm-soli">
                      Transaction
                    </h2>
                    <div className="prototype-img divido-proto mb-3 flex-shrink-0">
                      <img src={DividoTrans} alt="Wire frame" />
                    </div>
                  </div>

                  <p className="fs-18 mt-2 lh-24px">
                    Shows all completed and ongoing transactions with clear
                    details. A globe icon visually represents loan progress and
                    related financial activities.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="my-5">
          <div className="container my-3">
            <h2 className="fs-36px mb-4 my-5">Visual Design</h2>
            <div className="row mb-4 align-items-center justify-content-center">
              <h2 className="text-center my-4 fs-28 fm-soli">Color</h2>
              <div className="col-md-3 col-6 my-3">
                <div className="h-300 rounded-10x visual-design-card card-1 bg-black">
                  <div className="content p-3">
                    <p className="text-white mb-2 fs-24">Charcoal Black</p>
                    <p className="text-white fs-20 fm-andi">#000000</p>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-6 my-3">
                <div className="h-300 rounded-10x visual-design-card card-2">
                  <div className="content p-3">
                    <p className="mb-2 fs-24">White</p>
                    <p className="fs-20 fm-andi">#FFFFFF</p>
                  </div>
                </div>
              </div>
              <div className="col-md-2 col-6 my-3">
                <div className="h-300 rounded-10x visual-design-card card-3 bg-p-yellow">
                  <div className="content p-3">
                    <p className="text-white mb-2 fs-24">Pastel Yellow</p>
                    <p className="fs-20 fm-andi">#FFE893</p>
                  </div>
                </div>
              </div>
              <div className="col-md-2 col-6 my-3">
                <div className="h-300 rounded-10x visual-design-card card-4 bg-gradient-divido">
                  <div className="content p-3">
                    <p className="text-white mb-2 fs-24">Light Gray</p>
                    <p className="text-white fs-20 fm-andi">#EFEFEF</p>
                  </div>
                </div>
              </div>
              <div className="col-md-9 my-3">
                <p className="fs-24 lh-28x text-center">
                  Color in UI design enhances user experience, conveys brand
                  identity, creates visual hierarchy, improves accessibility,
                  evokes emotions, and ensures a cohesive and engaging
                  interface.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="typograpy">
          <div className="container">
            <div className="row justify-content-center">
              <h2 className="text-center mb-4 fs-28 fm-soli">Typography</h2>
              <div className="col-md-12">
                <div className="row mx-3 justify-content-center">
                  <div className="col-md-5 my-3">
                    <div className="font-card d-flex align-items-center justify-content-center">
                      <p className="mb-0 fs-32px lh-24x">Inter</p>
                    </div>
                  </div>
                  <div className="col-md-5 my-3">
                    <div className="font-card font-card-2 d-flex align-items-end">
                      <p className="mb-0 fs-32px lh-24x fm-sans">Aa</p>
                    </div>
                  </div>
                  <div className="col-md-9 mt-2">
                    <p className="fs-24 lh-28x text-center">
                      Typography in UI design enhances readability, establishes
                      brand personality, creates hierarchy, improves user
                      experience, ensures accessibility, and maintains visual
                      consistency across the interface.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="my-5">
          <div className="container my-3">
            <h2 className="fs-36px mb-4 my-5">Usability Testing</h2>
            <div className="row mb-4 align-items-center justify-content-center">
              <h2 className="my-4 mb-1 fs-28 fm-soli">
                User: I’d love to get reminders for FASTag and electricity
                recharges so I don’t forget to pay on time!
              </h2>
              <div className="col-md-5 my-3">
                <div className="d-flex align-items-center gap-3">
                  <div className="price-drop-img divido-drop mx-auto flex-shrink-0">
                    <img src={DividoFastag} alt="Price Drop Image" />
                  </div>
                  <p className="fs-18">
                    The Billbox screen shows recharge expiry and validity dates.
                    It also provides reminders for mobile recharges,
                    electricity, FASTag, and more.
                  </p>
                </div>
              </div>
              <div className="col-md-8 my-3"></div>
            </div>
            <div className="row mb-4 align-items-center justify-content-center">
              <h2 className="my-4 mb-1 fs-28 fm-soli">
                User: A 'Split with Friends' option would be really helpful for
                managing shared expenses effortlessly.
              </h2>
              <div className="col-md-5 my-3">
                <div className="d-flex align-items-center gap-3">
                  <div className="price-drop-img divido-drop mx-auto flex-shrink-0">
                    <img src={DividoSplit} alt="Price Drop Image" />
                  </div>
                  <p className="fs-18">
                    The Split screen lets you divide expenses instantly, and the
                    app keeps track of them easily.
                  </p>
                </div>
              </div>
              <div className="col-md-8 my-3"></div>
            </div>
          </div>
        </section>
        <Learnings />
      </section>
    </>
  );
};

export default DividoBody;
